<template>
  <div class="rating-and-reviews margin-bottom-m">
    <h3 class="margin-bottom-m">
      Ratings & Reviews
    </h3>

    <div class="grid-x">
      <div class="cell large-2 small-12">
        <AverageRating
          :reviews-count="reviewStatistics.count"
          :total-count="totalCount"
          :average-rating="averageRating"
        />
      </div>

      <div class="large-1 cell" />

      <div class="stars-rating-snapshot cell large-4 medium-5 small-12">
        <StarRatingSnapshot :count-per-rating="countPerRating" />
      </div>

      <div class="large-1 medium-1 hide-for-small-only cell" />

      <div
        v-if="sliders && sliders.length"
        class="cell large-4 medium-6 small-12 grid-x align-right small-margin-top-m medium-margin-top-z"
      >
        <div class="fitsliders grid-y cell">
          <Fitslider
            v-for="({ value, valueRange, title, minLabel, midLabel, maxLabel }, index) in sliders"
            :key="title + index"
            :value="value"
            :value-range="valueRange"
            :title="title"
            :labels="{ minLabel, midLabel, maxLabel }"
          />
        </div>
      </div>

      <div
        v-if="photos.length"
        :data-testid="reviewsStatisticsPhotosBlock"
        :class="`cell ${photoBlockMargins} ${photosDesktopWidth} small-12 customer-images-container`"
      >
        <CustomerImagesBlock
          :photos="photos"
          :is-on-two-lines="isPhotosOnSecondLine"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

import { useReviewsStatistics } from '@composables/reviews/useReviewsStatistics';
import { useCommonProductGetters } from '@composables/useCommonProductGetters';

import StarRatingSnapshot from './StarRatingSnapshot';
import Fitslider from '../../Fitslider';
import CustomerImagesBlock from './CustomerImagesBlock';
import AverageRating from './AverageRating';
import { reviewsStatisticsPhotosBlock } from '../../../constants/testIds';

const {
  averageRating, totalCount, countPerRating, sliders, photos,
} = useReviewsStatistics();
const { reviewStatistics } = useCommonProductGetters();

const isPhotosOnSecondLine = computed(() => (sliders.value.length ? true : photos.value.length > 3));
const photosDesktopWidth = computed(() => `large-${isPhotosOnSecondLine.value ? 12 : 4}`);
const photoBlockMargins = computed(() => (isPhotosOnSecondLine.value ? 'large-margin-top-xl small-margin-top-m' : 'large-margin-top-z small-margin-top-m'));
</script>

<style scoped lang="scss">
.stars-rating-snapshot {
  display: flex;
  flex-direction: column;
  gap: rem-calc(16);
}
.fitsliders {
  gap: rem-calc(24);
}
.customer-images-container {
  z-index: 1;
}
</style>
